import { Space } from '@sravni/react-design-system';

import type { TProductTypeTabId } from 'entities/creditForm';

import type { TProductTypeTabConfig } from '../../types';
import { ProductTypeCard } from '../ProductTypeCard/ProductTypeCard';

import styles from './ProductTypeCardList.module.scss';

type TProductTypeCardListProps = {
  tabs: TProductTypeTabConfig[];
  activeTabId: TProductTypeTabId;
  onSelectTab: (tabId: TProductTypeTabId) => void;
};

export const ProductTypeCardList = ({ tabs, activeTabId, onSelectTab }: TProductTypeCardListProps) => (
  <Space
    className={styles.list}
    size={8}
  >
    {tabs.map((tab) => (
      <ProductTypeCard
        key={tab.id}
        tab={tab}
        isSelected={activeTabId === tab.id}
        onSelect={() => onSelectTab(tab.id)}
      />
    ))}
  </Space>
);
